// extracted by mini-css-extract-plugin
module.exports = {"custom-form":"labelForm_custom-form__3xddJ"};